import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {ReactComponent as CrossIcon} from "assets/img/svg/CrossIcon.svg"
import "./style.scss";
import ListComponent from './ListComponent';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ALoader from 'views/pages/manage/common/a-loader';
import { getJodoHistory } from '../../apis';
const JodoHistoryPopup=({isOpen,setOpen,psId})=>{

const [loader,setLoader] = useState(false)
const [jodoHistoryData,setJodoHistoryData] = useState([{}])

useEffect(()=>{
    setLoader(true);
    getJodoHistory(psId)
      .then((data) => {
        data?.code === 200 && setJodoHistoryData(data?.data?.jodoHistoryList.map((item,index)=>{return{...item,id:index}}));
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
},[])

    return(
    <Dialog
        open={isOpen}
        PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}
      >
        <div className="select-concession-popup">
          <div className="d-flex " style={{ justifyContent: "space-between" }}>
            {loader&& <ALoader/>}
            <div className="heading-4 color-dark" >JODO History </div>
            <CrossIcon onClick={()=>setOpen(false)}/>

            </div>
            <ListComponent loader={loader} rows={jodoHistoryData} />
    </div>
    </Dialog>
    )
}
export default JodoHistoryPopup 